import styled from "styled-components";

export const Button = styled.button`
  // reset
  text-decoration: none;
  -webkit-appearance: none;
  -moz-appearance: none;

  // normalize
  font-family: "Rubik", sans-serif;
  font-weight: 500;
  font-size: 15px;
  line-height: 20px;

  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 160px;
  width: fit-content;

  padding: 16px 40px;
  box-sizing: border-box;
  border-radius: 6px;

  transition: all 0.2s ease 0s;
  cursor: ${(props) => (props.isLoading ? "not-allowed" : "pointer")};

  color: white;
  background-color: #1e22ff;
  border: 1px solid #1e22ff;

  &:hover {
    color: #1e22ff;
    background-color: transparent;
    border: 1px solid #1e22ff;
  }

  &:active {
    color: #1e22ff;
    background-color: transparent;
    border: 1px solid #1e22ff;
  }

  &[disabled] {
    color: white;
    background-color: ${(props) => (props.isLoading ? "#1e22ff" : "rgba(30, 34, 255, 0.5)")};
    border: 1px solid #898bfa;
    user-select: none;
    cursor: not-allowed;
  }
`;
